import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Logo from '../assets/logo.png';
import { TvMinimalPlay, Radio, House, Heart, LockKeyhole, KeyRound, TableOfContents, Info , CircleUserRound } from 'lucide-react';
import OffCanvas from '../Components/OffCanvas'; // Import Offcanvas component

export default function Sidebar({ data }) {

    const navigate = useNavigate();

    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
    const [offCanvasTitle, setOffcanvasTitle] = useState('');
    const [user, setUser] = useState('');


    const handleClick = (category) => {
        navigate('/category', { state: { category } });
    };

    const openOffcanvas = (content) => {
        setOffcanvasTitle(content);
    };

    useEffect(() => {
        setUser(JSON.parse(localStorage.getItem("AV_User_Data")))
        const handleResize = () => {
            setIsMobile(window.innerWidth < 768);
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    if (isMobile) {
        return (
            <>
                <div className="mobile-nav">
                    <nav className="bottom-nav d-flex justify-content-around align-items-center">
                        <button className="nav-button" onClick={() => navigate('/home')}>
                            <House size={24} />
                            <span>Home</span>
                        </button>
                        <button className="nav-button" onClick={() => navigate('/live')}>
                            <Radio size={24} />
                            <span>Live</span>
                        </button>
                        <button className="nav-button" onClick={() => navigate('/favorites')}>
                            <Heart size={24} />
                            <span>Favorites</span>
                        </button>
                        <button className="nav-button" data-bs-toggle="offcanvas" data-bs-target="#categoriesOffcanvas">
                            <TableOfContents size={24} />
                            <span>Categories</span>
                        </button>
                    </nav>
                </div>

                <div className="offcanvas offcanvas-bottom h-50" tabIndex="-1" id="categoriesOffcanvas" aria-labelledby="categoriesOffcanvasLabel">
                    <div className="offcanvas-header">
                        <h5 className="offcanvas-title" id="categoriesOffcanvasLabel">Categories</h5>
                        <button type="button" className="btn-close" data-bs-dismiss="offcanvas" aria-label="Close"></button>
                    </div>
                    <div className="offcanvas-body">
                        <ul className="list-group">
                            {data?.map((item, index) => (
                                <li className="list-group-item d-flex gap-1 align-items-center" key={index} onClick={() => handleClick(item)} data-bs-dismiss="offcanvas">
                                    <TvMinimalPlay strokeWidth={2} />
                                    {item.Name}
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
            </>
        );
    }

    return (
        <div className="sidebar">
            <div className='d-flex flex-column  align-items-start mt-3'>
                <img src={Logo} alt="Logo" className="logo" style={{ height: '40px', paddingLeft:'0.5rem' }} />
            </div>

            <li className='d-flex gap-1 align-items-center mt-2' onClick={() => navigate('/live')}>
                <Radio color="red" strokeWidth={3} />
                Live Stream
            </li>
            <li className='d-flex gap-1 align-items-center' onClick={() => navigate('/home')}>
                <House />
                Home
            </li>
            <hr />

            {data.length !== 0 ? (
                <ul className="sidebar-menu">
                    {data?.map((item, index) => (
                        <li className='d-flex gap-1 align-items-center' key={index} onClick={() => handleClick(item)}>
                            <TvMinimalPlay strokeWidth={2} />
                            {item.Name}
                        </li>
                    ))}
                </ul>
            ) : (
                <div>
                    {[...Array(10)].map((_, i) => (
                        <p key={i} className="placeholder-glow">
                            <span className="placeholder col-12 span-placeholder"></span>
                        </p>
                    ))}
                </div>
            )}

            <hr />

            <div className='d-flex flex-column'>
                <li className='d-flex gap-1 align-items-center' onClick={() => navigate('/favorites')}>
                    <Heart color="red" strokeWidth={3} />
                    Favorites
                </li>

                {user?.ShowTC === true ?
                <li className='d-flex gap-1 align-items-center' data-bs-toggle="offcanvas" data-bs-target="#infoOffcanvas" onClick={() => openOffcanvas('Terms & Conditions')}>
                    <KeyRound />
                    Terms & Conditions
                </li> : ""}


                {user?.ShowPP === true ?
                <li className='d-flex gap-1 align-items-center' data-bs-toggle="offcanvas" data-bs-target="#infoOffcanvas" onClick={() => openOffcanvas('Privacy Policy')}>
                    <LockKeyhole />
                    Privacy Policy
                </li> : ""}


                {user?.showMyAccountDetails === true ?
                <li className='d-flex gap-1 align-items-center' data-bs-toggle="offcanvas" data-bs-target="#infoOffcanvas" onClick={() => openOffcanvas('My Account')}>
                    <CircleUserRound />
                    My Account
                </li> : ""}



                {user?.showUnsub === true ?
                <li className='d-flex gap-1 align-items-center' data-bs-toggle="offcanvas" data-bs-target="#infoOffcanvas" onClick={() => openOffcanvas('Subscription Information')}>
                    <Info />
                    Subscribtion Info
                </li> : ""}


            </div>

            {/* Inject Offcanvas Component */}
            <OffCanvas id="infoOffcanvas" title={offCanvasTitle}  />
        </div>
    );
}
